import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faPlus } from '@fortawesome/free-solid-svg-icons';

import { addAll, removeAll } from 'Redux/ducks/cart';
import Price from 'Components/Utility/Price/Price';

import 'Components/PickAndMix/PickAndMixAddAll.scss';

const PickAndMixAddAll = ({
  tiers,
  products,
  selectedProducts,
  addAll: _addAll,
  removeAll: _removeAll,
}) => {
  if (isEmpty(tiers) || isEmpty(products)) return false;
  const lastTier = tiers[(tiers.length - 1)];
  const productsCount = products && products.length;
  const selectedProductsCount = selectedProducts && selectedProducts.length;

  if (productsCount !== lastTier.quantity) return false;

  const showRemove = selectedProductsCount === productsCount;

  return (
    <div className="PickAndMixAddAll">
      <div className="PickAndMixAddAll__message">
        <FormattedMessage
          id="PickAndMixAddAll.addall"
          defaultMessage="Add all for {price}"
          values={{
            price: <Price price={lastTier.price} />,
          }}
        />
      </div>
      <div className="PickAndMixAddAll__buttons">
        {showRemove ?
          <button className="btn PickAndMixAddAll__buttons__removeButton" onClick={() => _removeAll(products.map(p => p._id))}>
            <FontAwesomeIcon icon={faTrashCan} className="mr-1" />
            <FormattedMessage id="PickAndMixAddAll.button.removeallfromcart" defaultMessage="Remove all" />
          </button>
          :
          <button className="btn btn-primary PickAndMixAddAll__buttons__addButton" onClick={() => _addAll(products.map(p => p._id))}>
            <FontAwesomeIcon icon={faPlus} className="mr-1" />
            <FormattedMessage id="PickAndMixAddAll.button.addalltocart" defaultMessage="Add all" />
          </button>
        }
      </div>
    </div>
  );
};

PickAndMixAddAll.propTypes = {
  selectedProducts: PropTypes.arrayOf(PropTypes.object),
  tiers: PropTypes.arrayOf(PropTypes.object),
  products: PropTypes.arrayOf(PropTypes.object),
  addAll: PropTypes.func.isRequired,
  removeAll: PropTypes.func.isRequired,
};

PickAndMixAddAll.defaultProps = {
  selectedProducts: [],
  tiers: [],
  products: [],
};

export default connect(null, { addAll, removeAll })(PickAndMixAddAll);
